module.exports = __webpack_public_path__ + "static/media/library-promo.0002ca00.png";